import { render, staticRenderFns } from "./accessRecordStatistics.vue?vue&type=template&id=0b27fdaa&scoped=true&"
import script from "./accessRecordStatistics.vue?vue&type=script&lang=js&"
export * from "./accessRecordStatistics.vue?vue&type=script&lang=js&"
import style0 from "./accessRecordStatistics.vue?vue&type=style&index=0&id=0b27fdaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27fdaa",
  null
  
)

export default component.exports